<template>
  <b-card border-variant="dark" align="center" class="rounded-custom-1 border-custom-2 pt-2">
    <b-row class="justify-content-center">
      <b-col md="10">
        <b-card-title class="sign-up-title">Create a new workspace</b-card-title>
        <envelope-image />
        <b-card border-variant="dark" align="left" class="rounded-custom-1 border-custom-2 m-0 m-md-3">
          <b-row class="justify-content-center">
            <b-col md="8">
              <b-card-title class="text-center mb-4">
                To create a new workspace, please enter a name and confirm your email address.
              </b-card-title>
              <create-workspace-form
                :submitting="submitting"
                :state="state"
                @submit="onSubmit"
                @googlesubmit="onSubmitGoogle"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { googleSignUpManagerUrl } from '@/helpers/external'
import CreateWorkspaceForm from '@/components/forms/CreateWorkspaceForm.vue'
import EnvelopeImage from '@/assets/images/envelope.svg'

export default {
  name: 'CreateWorkspace',

  data() {
    return {
      state: {},
      submitting: false
    }
  },

  methods: {
    onSubmit(formData) {
      this.submitting = true
      this.$store.dispatch('companySignUp', formData)
        .then(response => {
          this.$router.push({ name: 'CheckEmail' })
        })
        .catch(errors => { this.state = errors })
        .finally(() => { this.submitting = false })
    },

    onSubmitGoogle(formData) {
      this.submitting = true
      const name = formData.name
      this.$store.dispatch('companySignUpCheckName', name)
        .then(() => {
          location.href = googleSignUpManagerUrl(name)
        })
        .catch(errors => { this.state = errors })
        .finally(() => { this.submitting = false })
    }
  },

  components: {
    CreateWorkspaceForm,
    EnvelopeImage
  }
}
</script>
